// Types personalisés
import BaseTreeNode from "@/types/BaseTreeNode";
import Pin from "@/types/FilterTree/Pin";
import SaveModeEnum from "@/enums/SaveModeEnum";
import ObjectDashboard from "@/types/Dashboard/ObjectDashboard/ObjectDashboard";
import ObjectWidget from "@/types/Dashboard/ObjectDashboard/ObjectWidget";
// Machine à état 
import { ObjDashAdminSelected } from "./ObjDashAdminSelected";
import { EMPTY_OBJECT_DASHBOARD_ID, ObjectDashAdminState } from "./IObjectDashAdminState";
import BaseObjectTypeEnum from "@/enums/BaseObjectTypeEnum";


/** 
 * Classe représentatant un store "ObjectDashboardStore" avec un node "objectType" selectionné ou sans selection.
 * Nous sommes limité à la selection d'un noeud ou la création d'un nouveau tableau
 */
export class ObjDashAdminEmpty extends ObjectDashAdminState {
    
    /** 
     * Selectionne le noeud de l'arborescence des objets types et l'inscrit dans le context
     * @param dashNode noeud de l'arborescence des objets types
     */
    async SelectDashNode(dashNode: BaseTreeNode): Promise<void> {
        /** Inscrit le noeud dans la selection courante */
        this.store.context.commit('setDashNode', dashNode);

        /** Analyse le noeud pour découvrir si l'on doit charger un tableau de bord */
		if(dashNode.DashboardRef !== null){
            /** Charger les informations si il existe déjà */ 
			await this.loadDashboard(dashNode.DashboardRef);
            /** Fait avancer l'état vers un état  */
            this.store.context.commit('setLoadState', new ObjDashAdminSelected(this.store));
        }
        else
        {
            /** Un tableau de bord vide sert de tableau de bord par défaut pour les object type donc on fait comme si il existait un tableau */
		    this.store.context.commit('setSaveMode', { saveMode: SaveModeEnum.UpdateObject });

            /** Nettoye le tableau de bord */
            this.store.context.commit('setObjectDash', {
                Id: EMPTY_OBJECT_DASHBOARD_ID,
                Name: '',
                Widgets: [],
                ObjectType: BaseObjectTypeEnum.Root,
                ProfileIds: [],
                Pins: []
            });
        }
    }
    
    /** 
     * Créer un nouveau Dashboard vierge 
     * @param dashNode noeud de l'arborescence des objets type de référence pour la création du tableau
     * @param [profileIds=[]] Liste de profils attachés à ce tableau
     * @param [pins=[]] Liste de pin attachés à ce tableau
     * @param [widgets=[]] Liste des widgets attachés à ce tableau
     */
    async CreateDashboard(dashNode: BaseTreeNode, profileIds: number[] = [], pins: Pin[] = [], widgets = [] ): Promise<void> {
        /** Place la selection sur le node responsable de l'ajout */
		this.store.context.commit('setDashNode', dashNode)

        /** Un suffixe est ajouté au nom à partir de l'incrément (lorsqu'il ne s'agit pas d'un dashboard par défaut) */
		const newId: number = EMPTY_OBJECT_DASHBOARD_ID - dashNode.Children.length - 1
        const fullName: string = dashNode.Name + "_" + (dashNode.Children.length + 1);

        /** Contruit le noeud et l'ajoute dans le père */
        const newDashNode: BaseTreeNode = await this.newDashNode(fullName,dashNode, newId);
        /** Construit le nouveau tableau de bord */
        const newDashboard: ObjectDashboard = await this.newDashboard(fullName,newId,dashNode,profileIds,pins,widgets);

        /** Passe le SaveMode en New */
		this.store.context.commit('setSaveMode', { saveMode: SaveModeEnum.NewObject });
        /** Stocke le tableau et le nouveau noeud */
        this.store.context.commit('setDashNode', newDashNode);
		this.store.context.commit('setObjectDash', newDashboard);

        /** Finalise la transition et passe au suivant */
        this.store.context.commit('setLoadState', new ObjDashAdminSelected(this.store));
    }

    /** 
     * Supprime un tableau de bord
     * @param dashnode  noeud lié au tableau que l'on disire supprimer 
     */
    async RemoveDashboard(dashnode: BaseTreeNode): Promise<void> { 
        /** Si pas de tableau de bord il n'y a rien à supprimer */
        if(!dashnode.DashboardRef) return;
        /** Supression du tableau de bord */
        this.removeDashboard(dashnode);
    }

//#region VIDE CAR : Inutile à cette étape 
    /** Inutile à cette étape */
    Clear(): void { 
        console.debug("ObjDashAdminEmpty - Clear()");
    }
    /** Inutile à cette étape : déjà chargé */
    async LoadTree(nodeIdToSelect: string): Promise<void> { 
        console.debug("ObjDashAdminEmpty - LoadTree() - nodeIdToSelect : ", nodeIdToSelect);
    }
    /** Inutile à cette étape : pas de tableau de bord */
    async SaveDashboard(dashboard: ObjectDashboard): Promise<void> {
        console.debug("ObjDashAdminEmpty - SaveDashboard() - dashboard : ", dashboard);
    }
    /** Inutile à cette étape : pas de tableau de bord */
    AddWidget(widget: ObjectWidget): void {
        console.debug("ObjDashAdminEmpty - AddWidget() - widget : ", widget);
    }
    /** Inutile à cette étape : pas de tableau de bord */
    RemoveWidget(widgetId: number): void {
        console.debug("ObjDashAdminEmpty - RemoveWidget() - widgetId : ", widgetId);
     }
    /** Inutile à cette étape : pas de tableau de bord */
    async UpdateWidgetParameters(widgetId: number, parameters: any, name: string | undefined): Promise<void> { 
        console.debug("ObjDashAdminEmpty - UpdateWidgetParameters() - widgetId : ", widgetId);
    }
    /** Inutile à cette étape : pas de tableau de bord */
    async UpdateWidget(widgetId: number, datas: any) { 
        console.debug("ObjDashAdminEmpty - UpdateWidget() - widgetId : ", widgetId);
    }
//#endregion

}